import React, { FC } from 'react'

import { IconSizes, IconWeight } from '@inno-ui/icons'
import { motion } from 'motion/react'

import styles from './ControlButton.module.scss'
import { ControlButtonProps } from './ControlButton.types'

export const ControlButton: FC<ControlButtonProps> = ({
  icon: Icon,
  ...props
}) => {
  return (
    <motion.button
      {...props}
      className={styles.controlButton}
      onDoubleClick={e => {
        e.stopPropagation()
      }}
    >
      <Icon
        size={IconSizes.Size16}
        color='currentColor'
        weight={IconWeight.Bold}
      />
    </motion.button>
  )
}
